import React, { FunctionComponent } from 'react'
import CollapsingItem from '../Common/CollapsingItem'
import Row from '../Common/Row'
import { Text } from '@wework/dieter-ui'
import css from './Permissions.module.scss'
import ScheduleTag, { ScheduleTags } from './Schedule/ScheduleTag'

interface PermissionsProps {
  space: any
}

interface PermissionsData {
  id: string
  company: String
  tag: ScheduleTags
  isPermitted
}

const Permissions: FunctionComponent<PermissionsProps> = ({ space }) => {
  const permissions: Array<PermissionsData> = space.permissions || [
    {
      id: '1',
      tag: 'PHYSICAL',
      company: 'ACME company',
      isPermitted: false,
    },
    {
      id: '2',
      tag: 'ON DEMAND',
      company: 'ACME company',
      isPermitted: true,
    },
  ]
  const getPermissionItem: (priceData: PermissionsData) => JSX.Element = ({
    id,
    tag,
    company,
    isPermitted,
  }) => {
    return (
      <div key={id} className={css.permissionItem}>
        <Text className={css.permissionBoldText}>{company}</Text>
        <Row className={css.permissionTag}>
          <ScheduleTag key={tag} type={tag} />
        </Row>
        <Text className={css.permissionText}>
          {isPermitted ? 'Permitted' : 'Not Permitted'}
        </Text>
      </div>
    )
  }

  return (
    <CollapsingItem title={'Permissions'}>
      {permissions.map(priceData => getPermissionItem(priceData))}
      <Text className={css.text}>
        <span className={css.clickableText} onClick={() => {}}>
          {'12 other permissions'}
        </span>
        {`\s`}set for this location.
      </Text>
    </CollapsingItem>
  )
}

export default Permissions
